import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {VideoComponent} from './video.component';
import {AudioModule} from '../audio/audio.module';
import {OverlayModule} from '../overlay/overlay.module';
import {BufferModule} from '../buffer/buffer.module';
import {FrameAccurateModule} from '../frame-accurate/frame-accurate.module';
import {TimelineModule} from '../timeline/timeline.module';
import {ErrorModule} from '../error/error.module';
import {ApiModule} from '../api/api.module';
import {InteractionModule} from '../interaction/interaction.module';

@NgModule({
    declarations: [VideoComponent],
    imports: [
        CommonModule,
        AudioModule,
        OverlayModule,
        BufferModule,
        FrameAccurateModule,
        TimelineModule,
        ErrorModule,
        ApiModule,
        InteractionModule
    ],
    exports: [
        VideoComponent
    ]
})
export class VideoModule {}
